import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { FormBuilder, FormGroup, Validators, FormGroupDirective } from '@angular/forms';
import { ValidatorsService } from 'src/app/services/validators/validators.service';
import { AuthPageManageService } from '../../../services/manage/page-manage/auth-page-manage.service';
import { ToolsService } from '../../../services/tools/tools.service';
import { SmsnotificationsService } from 'src/app/services/apiclient/smsnotifications/smsnotifications.service';
import { CountriesService } from 'src/app/services/apiclient/countries/countries.service';
import { parsePhoneNumberFromString } from 'libphonenumber-js'
import {CssService} from "../../../services/css-service";

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {

  // Sms notif
  @Input() smsNotif: any;

  // Nom de la page ou rediriger
  @Input() redirectPage: string | any;

  // Valeur de l'input du code à renseigné pour la sms notif
  smsNotifInputValue: string | any;

  // Message d'erreur lié à la sms notif
  errorCodeSmsNotifMessage: string | any;

  // Message d'erreur lié à l'authentification et la création de compte en général
  error$: string | any;

  // Pays
  countries$: any[] | any;

  // Pays séléctionné
  selectedCountry: any;

  // Formulaire angular de création de compte
  registerForm: FormGroup | any;

  // Email attaché au formulaire en cours (Servira pour les messages lié à l'adresse mail)
  currEmail: string | any;

  // Les différents loaders
  loaders: any = {
    page: false,
    countries: false
  }

  constructor(
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private vs: ValidatorsService,
    public cssService: CssService,
    private smsNotifApi: SmsnotificationsService,
    public authManPag: AuthPageManageService,
    private tools: ToolsService,
    private countriesApi: CountriesService,
    public smsApi: SmsnotificationsService
  ) { }

  ngOnInit() {
    this.createRegisterForm();
    this.getCountries();
    this.getAuthError();
  }

  /**
   * @description Récupère les pays et ensuite set les données par defaut via la fonction setDefaultData()
   * @return {Void}
   */
  getCountries(): void {
    this.loaders.countries = true;
    this.countriesApi.getCountries().subscribe(countries => {

      this.countries$ = countries;
      this.setDefaultData();
      this.loaders.countries = false;
    })
  }

  /**
   * @description Initialise la subscritpion à l'observable erreur du service authService
   * @return {Void}
   */
  getAuthError(): void {
    this.authService.getError.subscribe((data) => {
      this.error$ = data;
    });
  }

  /**
   * @description Récupère la sms notif avec le code renseigné dans l'input prévu à cet effet
   * @return {Void}
   */
  getSmsNotif(): void {


    this.loaders.page = true;
    this.errorCodeSmsNotifMessage = "";


    this.smsNotifApi.getSmsNotification(this.smsNotifInputValue).then(data => {

      if (data.code === 0) {

        this.authManPag.setSmsNotif(data.sms_notification);
        this.smsNotif = data.sms_notification;
        this.setDefaultData();

      } else {

        this.errorCodeSmsNotifMessage = data.message;

      }

      this.loaders.page = false;

    })

  }

  /**
   * @description Initialise et set le formulaire registerForm
   * @return {void}
   */
  createRegisterForm(): void {
    this.registerForm = this.formBuilder.group({
      lastname: ['', [Validators.required]],
      firstname: ['', [Validators.required]],
      phone: ['', [Validators.required, Validators.pattern("[^a-zA-Z]{1,}")]],
      id_country: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      confPassword: ['', [Validators.required]],
      enable_marketing: [''],
      society: ['']
    }, {
      validator: this.vs.MatchPassword
    });
  }

  /**
   * @description Incrémente les données par défaut
   * @return {Void}
   */
  setDefaultData(): void {


    let currCountry: any = this.countries$[0];

    // Input phone et select country
    const phoneInput: any = this.registerForm.get("phone");

    const countrySelect: any = this.registerForm.get("id_country");

    // Si sms notif il y a on set le pays et le numéro de tel qui correspondent à la sms notif et on disable les inputs
    if (this.smsNotif) {

      // On utilise un librairie pour récupérer un objet phone (country... etc) via le numéro string
      const phoneNumber: any = parsePhoneNumberFromString(this.smsNotif.phone);

      // On set la variable currCountry avec le pays qui correspond à l'objet phone
      for (let i = 0; i < this.countries$.length; i++) {
        if (this.countries$[i].code === phoneNumber.country) {
          currCountry = this.countries$[i];
          break;
        }
      }

      // Set de l'input phone
      phoneInput.setValue(this.smsNotif.phone);

      // Disable de l'input phone et du select country
      phoneInput.disable();
      countrySelect.disable();

    }

    // Set du select country
    countrySelect.setValue(currCountry.id);
    this.setSelectedCountry(currCountry);
  }

  /**
   * @description Incrémente enable_marketing
   * @return {Void}
   */
  onChkChange(value: any) {
    this.registerForm.get("enable_marketing").setValue(value.checked);
  }


  /**
   * @description Set les infos utilisateurs récoltées via credential (google etc..) dans le formulaire
   * @param {any} userInfo
   */
  setUserInfoInputs(userInfo: any): void {

    if (userInfo.name) {
      let splitedName = userInfo.name.split(" ");
      let lastName = splitedName[1];
      let firstName = splitedName[0];
      this.registerForm.get("lastname").setValue(lastName);
      this.registerForm.get("firstname").setValue(firstName);
    }
  }

  /**
   * @description Incrémente la variable selectedCountry avec un object country
   * @param {Country} country
   * @return {Void}
   */
  setSelectedCountry(country: any): void {
    this.selectedCountry = country;
    this.setIndicatif();
  }

  setIndicatif() {


    if (this.registerForm.value.id_country && this.registerForm.value.id_country!==79) {
      let ind = this.countries$.find((value: any) => (value.id == this.registerForm.value.id_country));
      if (ind && ind.phone_code) {
        this.registerForm.get("phone").setValue(ind.phone_code);
      }
    }
  }
  /**
   * @description Gère l'envoie du formulaire de d'enregistrement
   * @param {FormGroupDirective} formDirective
   * @return {Void}
   */
  submitRegister(formDirective: FormGroupDirective): void {



    const that = this;
    const formVal = that.registerForm.value;



    formVal.enable_marketing = formVal.enable_marketing ? 1 : 0;
    // Set l'erreur actuelle à null avant tout
    that.error$ = "";

    // Si le formulaire est valide on continue
    if (that.registerForm.valid) {

      // Set de l'email actuel pour les messages à venir.
      that.currEmail = formVal.email;

      // Début du loader
      that.loaders.page = true;

      // Enregistrement du client (Voir description fonction)
      that.authService.registerEmailPass(formVal.email, formVal.password, formVal.phone, formVal.id_country, formVal.firstname, formVal.lastname, formVal.enable_marketing,formVal.society).then(() => {

        // Reset des données du formulaire
        that.tools.resetForm(formDirective, that.registerForm);

        // Fin du loader
        that.loaders.page = false;

        // Redirection sur la page de redirection renseignée
        that.tools.goRedirectPage(that.redirectPage);

      }).catch(() => {

        // Fin du loader
        that.loaders.page = false;

      });

    }

  }

  /**
   * @description Récupère le field du registerForm qui correspond au nom en parametre et check si il a été renseigné
   * @param {String} field
   * @return {Boolean}
   */
  isFieldrequired(field: string): boolean | any {
    let thisField = this.registerForm.controls[field];
    if (thisField.errors) {
      if (thisField.errors.required) {
        return true;
      }
    }
  }

}

